<template>
  <div>
    <FileDetailModal
      v-if="fileId"
      :id="fileId"
      @regenerate="reloadFilters"
      @close="onFileModalClose"
    />

    <TitleBar>
      <template v-slot:title>
        <translate>Downloads</translate>
      </template>
      <template v-slot:buttons>
        <GekkoButton
          :text="$gettext('Refresh')"
          icon="fa-solid fa-refresh"
          class="mr-2 position-relative"
          @click="reloadFilters"
          :loading="filesLoading"
        />
      </template>
    </TitleBar>

    <div class="content">
      <FilesTable ref="files-table" @loading="updateFilesLoadingState" />
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'
import FilesTable from '@/components/documents/FilesTable.vue'
import GekkoButton from '@/components/GekkoButton.vue'
import FileDetailModal from '@/components/documents/FileDetailModal.vue'

export default {
  name: 'Files',
  components: { FileDetailModal, GekkoButton, FilesTable, TitleBar },
  data() {
    return {
      fileId: null,
      filesLoading: false
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.fileId = this.$route.params['id']
      },
    },
  },
  methods: {
    updateFilesLoadingState (loading) {
      this.filesLoading = loading
    },
    reloadFilters() {
      if (this.$refs['files-table']) {
        this.$refs['files-table'].reloadFilterStore()
      }
    },
    onFileModalClose() {
      if (this.$route.name === "ControlPanelFileDetails") {
        this.$router.push({ name: 'ControlPanelFiles' })
      } else {
        this.$router.push({ name: 'Files' })
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
